import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';
import { flow } from 'lodash';
import { css } from 'aphrodite/no-important';
import styles from './styles';

const Types = {
  CARD: 'CARD',
};

const CardSource = {
  beginDrag(props) {
    return {
      index: props.index,
    }
  },
  endDrag(props, monitor) { // eslint-disable-line
    props.handleDndEnd();
  },
};

const CardTarget = {
  // 组件在target上方时触发的事件
  hover(props, monitor, component) {
    if (!component) return null;
    const node = ReactDOM.findDOMNode(component); // eslint-disable-line
    if (!node) return null;
    const dragIndex = monitor.getItem().index; // 拖拽目标的Index
    const hoverIndex = props.index; // 目标Index
    if (dragIndex === hoverIndex) return null; // 如果拖拽目标和目标ID相同不发生变化
    const hoverBoundingRect = node.getBoundingClientRect()
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = (clientOffset).y - hoverBoundingRect.top;
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
    props.handleDndHover(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};

function CardSourceCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }
}

function CardTargetCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  }
}

// 单项选择题
class DragCard extends Component {
  // 参数
  static propTypes = {
    content: PropTypes.any.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
  };

  // 渲染
  render() {
    const { content, connectDragSource, connectDropTarget, isDragging } = this.props;
    return connectDragSource(connectDropTarget(
      <div className={css([styles.cardBox, isDragging && styles.cardSelected])}>
        <div className={css(styles.cardText)}>{content}</div>
        <div className={css(styles.selectedIcon)} />
      </div>))
  }
}

export default flow(
  DragSource(Types.CARD, CardSource, CardSourceCollect),
  DropTarget(Types.CARD, CardTarget, CardTargetCollect),
)(DragCard);



// WEBPACK FOOTER //
// ./src/components/questions/sort/drag_card.js